import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import { Content, Line, Root } from './Card.styles'

/**
 * The Card's component.
 */
const Card = forwardRef((props, ref) => {
  const { children, enableBorder, enableHover, enableLine, lineColor, padding, ...restProps } = props

  return (
    <Root {...restProps} enableBorder={enableBorder} enableHover={enableHover} enableLine={enableLine} ref={ref}>
      {enableLine && <Line color={lineColor} />}
      <Content padding={padding}>{children}</Content>
    </Root>
  )
})

Card.defaultProps = {
  color: 'default',
  elevation: '0',
  enableBorder: false,
  enableHover: false,
  enableLine: false,
  height: 'auto',
  lineColor: 'primary',
  margin: 0,
  padding: '24px 16px',
  width: '100%'
}

Card.propTypes = {
  /**
   * Children.
   */
  children: PropTypes.node.isRequired,
  /**
   * Color.
   */
  color: PropTypes.oneOf(['blank', 'default', 'error', 'primary', 'success', 'warning']),
  /**
   * Elevation.
   */
  elevation: PropTypes.oneOf(['0', '1', '2', '3', '4']),
  /**
   * Enable border.
   */
  enableBorder: PropTypes.bool,
  /**
   * Enable hover.
   */
  enableHover: PropTypes.bool,
  /**
   * Enable line.
   */
  enableLine: PropTypes.bool,
  /**
   * Height.
   */
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Line color.
   */
  lineColor: PropTypes.oneOf(['default', 'error', 'primary', 'success', 'warning']),
  /**
   * Margin.
   */
  margin: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Padding.
   */
  padding: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Width.
   */
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
}

export default Card
